import MicroModal from 'micromodal';

import {
  fetchCart,
  checkProductAvailability,
  addSelectedSampleTypeToCart,
  fetchAccountLinks,
} from './api';

import {
  updateCartIndicator,
  getProductsProperties,
  getSelectedSampleTypeProperties,
  handleRequestSampleButtonClick,
  handleSampleTypesSelectChange,
  enableRequestSampleButton,
  disableRequestSampleButton,
  handleNotExistingProduct,
  handleNoExistingProducts,
  changeProductSizeInfoInModal,
  changeProductImageInModal,
  isProductAvailable,
  findRequestSampleModal,
  singleSampleType,
  findSampleTypesSelect,
  hideRequestSampleButton,
  showRequestSampleButton,
  hideRequestInfoButton,
  showRequestInfoButton,
  findAccountLinksToggle,
  setupAccountLinks,
} from './dom';

import { updateAnalyticsObectWithCartData } from '../helpers/adobe-analytics';
import threeformSession from '../modules/threeform-session';

import find from 'lodash/find';

const requestSampleModalId = 'modal-request-sample',
  requestSampleModalOpenClass = 'is-open';

let accountInformationRequest = null,
  accountInformationSyncInitialized = false;

export const loadAccountInformation = async () => {
  const accountLinksElement = document.querySelector('.js-account-links');

  if (!accountLinksElement || !findAccountLinksToggle()) return;

  if (accountInformationRequest) return accountInformationRequest;

  accountInformationRequest = (async () => {
    const accountLinksHTML = await fetchAccountLinks();

    if (typeof accountLinksHTML === 'string') {
      accountLinksElement.innerHTML = accountLinksHTML;
    }

    setupAccountLinks();
  })();

  try {
    await accountInformationRequest;
  } finally {
    accountInformationRequest = null;
  }
};

const handleAuthenticatedUserUpdated = () => {
  loadAccountInformation();
};

export const setupAccountInformationSync = () => {
  if (accountInformationSyncInitialized) return;

  window.addEventListener(
    threeformSession.AUTHENTICATED_USER_UPDATED_EVENT,
    handleAuthenticatedUserUpdated
  );
  accountInformationSyncInitialized = true;
};

export const spreeIntegration = async () => {
  try {
    let cart;
    cart = await fetchCart();
    if (cart) {
      updateAnalyticsObectWithCartData(cart);
      updateCartIndicator(cart.data?.attributes?.item_count);
    }

    const productsProperties = getProductsProperties();
    if (!productsProperties) return;

    const includedPropertiesById = {};
    await Promise.all(
      productsProperties.map(async product => {
        if (!!product) {
          const { id, sampleTypeId } = product;
          if (typeof id === 'undefined' || id === '') return;

          const response = await checkProductAvailability(id);

          if (response.isFail() && sampleTypeId) {
            handleNotExistingProduct(sampleTypeId);
          } else {
            includedPropertiesById[id] = response.success().included;
          }
        }
      })
    );

    if (isProductAvailable()) {
      if (findSampleTypesSelect()) {
        handleSampleTypesSelectChange(event => {
          const sampleTypesSelect = event.target;
          if (
            typeof sampleTypesSelect.value !== 'undefined' &&
            sampleTypesSelect.value !== ''
          ) {
            const id =
              sampleTypesSelect.options[sampleTypesSelect.selectedIndex].dataset
                .productId;

            if (id) {
              showRequestSampleButton();
              enableRequestSampleButton(id);
              hideRequestInfoButton();

              if (
                findRequestSampleModal().classList.contains(
                  requestSampleModalOpenClass
                )
              ) {
                MicroModal.close(requestSampleModalId);
              }

              const productSize = find(includedPropertiesById[id], {
                  attributes: { name: 'size' },
                }),
                selectedSampleTypeProperties = getSelectedSampleTypeProperties();

              changeProductSizeInfoInModal(
                productSize.attributes.value,
                selectedSampleTypeProperties.cartModalInfo.sampleType
              );

              changeProductImageInModal(
                selectedSampleTypeProperties.cartModalInfo.imgSrc
              );
            } else {
              hideRequestSampleButton();
              showRequestInfoButton();
            }
          } else {
            disableRequestSampleButton();
          }
        });

        handleRequestSampleButtonClick(async () => {
          try {
            disableRequestSampleButton();
            cart = await addSelectedSampleTypeToCart(1);
            if (cart) updateCartIndicator(cart.item_count);
          } catch (error) {
            console.error(error);
            if (window.Sentry) Sentry.captureException(error);
          } finally {
            enableRequestSampleButton();
          }
        });

        if (singleSampleType()) {
          const sampleTypesSelect = findSampleTypesSelect(),
            sampleTypesOption = sampleTypesSelect.options[0],
            listeningElement = sampleTypesSelect.parentNode.querySelector(
              `[rel="${sampleTypesOption.value}"]`
            ),
            clickEvent = new Event('click');

          if (listeningElement) listeningElement.dispatchEvent(clickEvent);
        }

        findSampleTypesSelect().setAttribute('data-loaded', true);

        const sampleTypesSelect = findSampleTypesSelect(),
          selectedElement = sampleTypesSelect.parentElement.querySelector(
            `.styled-select li[rel="${sampleTypesSelect.value}"]`
          );
        if (selectedElement) selectedElement.dispatchEvent(new Event('click'));
      } else {
        showRequestSampleButton();
        enableRequestSampleButton();
      }

      handleRequestSampleButtonClick(async () => {
        try {
          disableRequestSampleButton();
          cart = await addSelectedSampleTypeToCart(1);
          if (cart) updateCartIndicator(cart.item_count);
        } catch (error) {
          console.error(error);
          if (window.Sentry) Sentry.captureException(error);
        } finally {
          enableRequestSampleButton();
        }
      });
    } else {
      handleNoExistingProducts();
    }
  } catch (error) {
    console.error(error);
    if (window.Sentry) {
      Sentry.captureException(error);
    }
    handleNoExistingProducts();
  }
};
